export interface Game {
  id: string;
  title: string;
  category: string;
  image: string;
  description?: string;
  isNew?: boolean;
  isHot?: boolean;
  isBanner?: boolean;
  enable: boolean;
  externalUrl?: string;
  orientation?: 'portrait' | 'landscape';
  apiGameId?: number; // Playsout API game ID
}

export const games: Game[] = [
  {
    id: 'PickaxeQuest',
    title: 'Pickaxe Quest',
    category: 'Adventure',
    image: '/images/games/PickaxeQuest.jpg',
    description: 'Mining and adventure game',
    isNew: true,
    isHot: false,
    enable: true,
    orientation: 'portrait',
    apiGameId: 70,
    externalUrl: 'https://games.playsout.com/demo/PickaxeQuest1/',
  },
  {
    id: 'CapybaraLink',
    title: 'Capybara Link',
    category: 'Puzzle',
    image: '/images/games/CapybaraLink.jpg',
    description: 'Puzzle game',
    isNew: true,
    isHot: false,
    enable: true,
    orientation: 'portrait',
    apiGameId: 10,
    externalUrl: 'https://games.playsout.com/demo/CapybaraLink1/',
  },
  {
    id: 'ProjectGarden',
    title: 'Project: Garden',
    category: 'Adventure',
    image: '/images/games/SimulatedAdventures.jpg',
    isNew: true,
    isHot: false,
    enable: true,
    orientation: 'portrait',
    apiGameId: 79,
    externalUrl: 'https://games.playsout.com/demo/Garden1/',
  },
  {
    id: 'MushroomWarriors',
    title: 'Mushroom Warriors',
    category: 'RPG',
    image: '/images/games/MushroomWarriors.jpg',
    isNew: true,
    isHot: false,
    enable: true,
    orientation: 'portrait',
    apiGameId: 80,
    externalUrl: 'https://games.playsout.com/demo/MushroomWarriors/',
  },
  {
    id: 'OneDoor',
    title: 'One Door',
    category: 'Arcade',
    image: '/images/games/OneDoor.jpg',
    isNew: true,
    isHot: false,
    enable: true,
    orientation: 'portrait',
    apiGameId: 20,
    externalUrl: 'https://games.playsout.com/demo/OneDoor/',
  },
  {
    id: 'Falling2048',
    title: 'Falling 2048',
    category: 'Casual',
    image: '/images/games/Falling2048.jpg',
    isNew: true,
    isHot: false,
    enable: true,
    orientation: 'portrait',
    apiGameId: 52,
    externalUrl: 'https://games.playsout.com/demo/Falling20481/',
  },
  {
    id: 'SaveTheKing',
    title: 'Save The King',
    category: 'Moba',
    image: '/images/games/savetheking.jpg',
    description: 'Strategy game, protect the king from enemy attacks',
    isNew: true,
    enable: true,
    orientation: 'portrait',
    apiGameId: 73,
  },
  {
    id: 'FishTankFury',
    title: 'Fish Tank Fury',
    category: 'Puzzle',
    image: '/images/games/FishTankFury.jpg',
    description: 'Fish tank game',
    isNew: true,
    isHot: false,
    enable: true,
    orientation: 'portrait',
    apiGameId: 2,
    externalUrl: 'https://games.playsout.com/demo/FishTankFury2/',
  },
  {
    id: 'KittyEscape',
    title: 'Kitty Escape',
    category: 'Puzzle',
    image: '/images/games/KittyEscape.jpg',
    description: 'Help the cat escape the maze',
    isNew: true,
    isHot: true,
    enable: true,
    orientation: 'portrait',
    apiGameId: 1,
    externalUrl: 'https://games.playsout.com/demo/KittyEscape/',
  },
  {
    id: 'KittyCrushSaga',
    title: 'Kitty Crush Saga',
    category: 'Arcade-Puzzle',
    image: '/images/games/Kitty Crush Saga.jpg',
    description: 'Puzzle game',
    enable: true,
    orientation: 'portrait',
    apiGameId: 3,
    externalUrl: 'https://games.playsout.com/demo/KittyCrushSaga/',
  },
];

// 获取所有启用的游戏
export const getEnabledGames = (): Game[] => {
  return games.filter(game => game.enable);
};

// 按类别分组的游戏（只包含启用的游戏）
export const gamesByCategory = {
  'Adventure': getEnabledGames().filter(game => game.category === 'Adventure'),
  'Arcade': getEnabledGames().filter(game => game.category === 'Arcade'),
  'Casual': getEnabledGames().filter(game => game.category === 'Casual'),
  'Moba': getEnabledGames().filter(game => game.category === 'Moba'),
  'RPG': getEnabledGames().filter(game => game.category === 'RPG'),
  'Puzzle': getEnabledGames().filter(game => game.category === 'Puzzle'),
  'Arcade-Puzzle': getEnabledGames().filter(game => game.category === 'Arcade-Puzzle'),
};

// 获取新游戏（只包含启用的游戏）
export const getNewGames = (): Game[] => {
  return getEnabledGames().filter(game => game.isNew);
};

// 获取热门游戏（返回所有启用的游戏，确保首页显示完整）
export const getHotGames = (): Game[] => {
  return getEnabledGames();
};

// 获取真正标记为热门的游戏（严格按照 isHot 标记过滤）
export const getMarkedHotGames = (): Game[] => {
  return getEnabledGames().filter(game => game.isHot);
};

// 获取Banner游戏（只包含启用的游戏）
export const getBannerGames = (): Game[] => {
  return getEnabledGames().filter(game => game.isBanner);
};

// 根据ID获取游戏（包含禁用的游戏，用于直接访问）
export const getGameById = (id: string): Game | undefined => {
  return games.find(game => game.id === id);
};

// 根据游戏ID获取API游戏ID
export const getApiGameId = (id: string): number | undefined => {
  const game = games.find(game => game.id === id);
  return game?.apiGameId;
};

// 根据ID获取启用的游戏
export const getEnabledGameById = (id: string): Game | undefined => {
  return getEnabledGames().find(game => game.id === id);
};

// 获取所有游戏类别（只包含启用游戏的类别）
export const getAllCategories = (): string[] => {
  return Array.from(new Set(getEnabledGames().map(game => game.category)));
};

// 搜索游戏（只在启用的游戏中搜索）
export const searchGames = (query: string): Game[] => {
  const lowercaseQuery = query.toLowerCase();
  return getEnabledGames().filter(game =>
    game.title.toLowerCase().includes(lowercaseQuery) ||
    game.category.toLowerCase().includes(lowercaseQuery) ||
    (game.description && game.description.toLowerCase().includes(lowercaseQuery))
  );
};
